import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { Stopwatch } from './Stopwatch';


// const fieldGap = 10;

// const fieldWidth = 82;
// const fieldHeight = 100;

// export const measureField = (index: number, total: number) => {

//     const areaWidth = width - (fieldWidth * total) - (fieldGap * (total - 1));
//     const areaHeight = height - fieldHeight;

//     const fieldX = (areaWidth / 2) + (fieldWidth * index) + (fieldGap * index);
//     const fieldY = (areaHeight / 2);

//     return new Rect(fieldX, fieldY, fieldWidth, fieldHeight);
// };

// export const measureButton = (ltr: boolean, total: number) => {

//     const buttonSize = 50;

//     const areaWidth = width - (fieldWidth * total) - (fieldGap * (total - 1));

//     const buttonX = (((width - areaWidth) / 2) / 2) - (buttonSize / 2);
//     const buttonY = (height - buttonSize) / 2;

//     const offset = ltr ? 0 : width - buttonX - buttonX - buttonSize;

//     return new Rect(buttonX + offset, buttonY, buttonSize, buttonSize);
// };

// export interface StopwatchLayout {
//     readonly width: number;
//     readonly height: number;
//     // readonly hours: Rect;
//     readonly inner: Rect;
//     readonly minutes: Rect;
//     readonly seconds: Rect;
//     readonly leftButton: Rect;
//     readonly rightButton: Rect;
// }

// const minutes = measureField(0, 2);
// const seconds = measureField(1, 2);
// const inner = Rect.fromMany([minutes, seconds]);
// const leftButton = measureButton(true, 2);
// const rightButton = measureButton(false, 2);
// return { width, height, minutes, seconds, inner, leftButton, rightButton };


export const StopwatchLayout = (object: Stopwatch) => {
    const { width, height } = object;

    const base = new Rect(0, 0, width, height);

    const startStop = Rect.fromCenter(
        base.pointAt(0, .5).add([15 + 20, 0]),
        20
    );

    const addTime = Rect.fromCenter(
        base.pointAt(1, .5).add([-15 - 20, 0]),
        20
    );

    const screen = Rect.fromCenter(
        base.pointAt(.5, .5),
        new Point(70, 40),
    );

    const half = (screen.width / 2) - 5;

    const minutes = screen.set({ width: half });
    const seconds = screen.set({ width: half, left: minutes.right + 10 });
    const colon = screen.set({ width: 10, left: minutes.right });

    return { base, startStop, addTime, screen, minutes, seconds, colon };
};

export type StopwatchLayout = ReturnType<typeof StopwatchLayout>;
